import { Component, Signal, effect, inject, signal, untracked } from "@angular/core";
import { Router, RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { NavComponent } from "./components/shared/nav/nav.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { SideNavItem } from "./models/sidenav-item";
import { ComponentRoutes } from "./models/constants/component-routes";
import { AuthStore } from "./stores/auth.store";
import { finalize } from "rxjs";

@Component({
    selector: "app-root",
    standalone: true,
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    imports: [
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        RouterModule,
        NavComponent,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
    ],
})
export class AppComponent {
    private _router: Router = inject(Router);

    public authStore: AuthStore = inject(AuthStore);

    public sidenavItems: Signal<SideNavItem[]> = signal<SideNavItem[]>([
        {
            icon: "sports_esports",
            title: "Offers",
            link: ComponentRoutes.offers.root,
        },
        {
            icon: "contacts",
            title: "Clients",
            link: ComponentRoutes.clients.root,
        },
        {
            icon: "groups",
            title: "Target groups",
            link: ComponentRoutes.targetGroups.root,
        },
        {
            icon: "emoji_events",
            title: "Achievements",
            link: ComponentRoutes.achievements.root,
        },
        {
            icon: "quiz",
            title: "Quests",
            link: ComponentRoutes.quests.root,
        },
        {
            icon: "analytics",
            title: "Offers Statistic",
            link: ComponentRoutes.offers.statistics,
        },
        {
            icon: "person",
            title: "Users Statistic",
            link: ComponentRoutes.users.root,
        },
        {
            icon: "casino",
            title: "Spin Wheel",
            link: ComponentRoutes.spinWheel.root,
        },
        {
            icon: "ad",
            iconFontSet: "material-symbols-outlined",
            title: "Banners",
            link: ComponentRoutes.banners.root,
        },
        {
            icon: "graph_1",
            iconFontSet: "material-symbols-outlined",
            title: "A/B Tests",
            link: ComponentRoutes.abTests.root,
        },
    ]);

    constructor(private titleService: Title) {
        this.titleService.setTitle(`${environment.appName} - Backoffice`);
        effect(
            () => {
                if (!this.authStore.isAuthorized()) {
                    untracked(() => {
                        this.authStore.refreshToken().subscribe(() => {
                            this._router.navigateByUrl(ComponentRoutes.offers.root);
                        });
                    });
                }
            },
            { allowSignalWrites: true },
        );
    }

    public logout(): void {
        this.authStore
            .logout()
            .pipe(finalize(() => this._router.navigateByUrl(ComponentRoutes.auth.root)))
            .subscribe();
    }
}
